import { Card } from "@/components/ui/card";

export const StatCard = ({ label, value, icon: Icon, accent = "blue", sub, testid }) => {
  const map = {
    blue: "bg-[#EBF3FA] text-[#0F4C81]",
    green: "bg-emerald-50 text-emerald-600",
    amber: "bg-amber-50 text-amber-600",
    rose: "bg-rose-50 text-rose-600",
    violet: "bg-violet-50 text-violet-600",
    slate: "bg-slate-100 text-slate-600",
  };
  return (
    <Card className="p-5 border border-slate-200/80 shadow-sm hover:shadow-md transition-shadow hover:-translate-y-0.5" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</div>
          <div className="mt-2 font-bold text-3xl tracking-tight text-slate-900" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{value}</div>
          {sub && <div className="text-xs text-slate-400 mt-1">{sub}</div>}
        </div>
        {Icon && (
          <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${map[accent]}`}>
            <Icon size={22} />
          </div>
        )}
      </div>
    </Card>
  );
};

export const TargetRing = ({ value, target, size = 160 }) => {
  const pct = target > 0 ? Math.min(100, Math.round((value / target) * 100)) : 0;
  const r = size / 2 - 14;
  const c = 2 * Math.PI * r;
  const off = c - (pct / 100) * c;
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="rm-target-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#E2E8F0" strokeWidth="14" fill="none" />
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#10B981" strokeWidth="14" fill="none" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={off} style={{ transition: "stroke-dashoffset 1s ease" }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="text-3xl font-extrabold text-slate-900" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{pct}%</div>
        <div className="text-xs text-slate-500 mt-0.5">of target</div>
      </div>
    </div>
  );
};
